const initialState = {
  email: "",
  user: "",
  canEdit: false
};

export default initialState;
